export default __webpack_public_path__ + "staticlp1/media/epoca-negocios.be5041dd.jpg";